export const LICENSED_CLINICIAN = { id: 1000, name: 'LICENSED CLINICIAN' };
export const SUPERVISED_CLINICIAN = { id: 1000, name: 'SUPERVISED CLINICIAN' };
export const SELF_PAY_LABEL = 'Self-pay (out of pocket)';
export const SELF_PAY_VALUE = 'self_pay';
